import { AuthState } from "src/base/Enums";
import { action } from "typesafe-actions";
import { AuthActionType } from "./types";

export function authStateChanged(state: AuthState) {
    return action(AuthActionType.AUTH_STATE_CHANGED, { state })
}
